/**
 * Sidebar tab display names — single source of truth for role checks (`canSeeTab`) and labels.
 */
export const SIDEBAR_TABS = {
  DASHBOARD: "Dashboard",
  USERS: "Users",
  SUBSCRIPTION: "Subscription",
  MANUAL_PURCHASE: "Manual Purchase",
  CSR_MANUAL_SUBSCRIPTION: "Manual Subscription",
  NOTIFICATIONS: "Notifications",
  ADMIN_ALERTS: "My Notifications",
  PROMOTIONAL_MESSAGES: "Promotional Messages",
  ADS: "Ads",
  BLOG: "Blog",
  USER_PROFILES: "User Profiles",
  CONTENT_REPORTS: "Content Reports",
  BANNED_USERS: "Banned Users",
  MATCH_USER: "Match User",
  APP_VERSION_CONTROL: "App Version Control",
  ADMIN_PANEL_USERS: "Admin Panel Users",
  BOOST_HISTORY: "Boost History",
  DUMMY_USERS: "Dummy Users",
  REFERRALS: "Referrals",
  SUPPORT: "Support Center",
  SUPPORT_TEAMS: "Teams",
  CSR_OUTREACH: "CSR Outreach",
  SALE_AGENT: "Sale Agent",
  CSR_LEADS: "CSR Leads",
  CHAT_SUPPORT_LOG: "Chat Support Log",
  CHAT_SUPPORT_ACTIVITY: "Chat / Email / Social",
  APPROVALS: "Approvals",
  SALES_CRM: "Sales CRM",
  AGENT_REPORTS: "Agent Reports",
  NASE_PRICES: "Nase Prices",
  CHAT_LIMITS: "Chat Limits",
  LOGIN_DEVICES: "Login Devices",
};
